<template>
  <v-dialog
    id="user-list-error-dialog"
    v-model="errorDialogDisplayed"
    max-width="640"
    persistent
  >
    <v-card>
      <v-card-title class="headline">{{ errorDialogTitle }}</v-card-title>
      <v-card-text>
        <v-alert
          id="user-list-error-dialog--error-alert"
          type="error"
          dense
          outlined
          class="mb-5"
        >
          <span v-html="errorDialogBody"></span>
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          id="user-list-error-dialog--closure-button"
          color="primary"
          @click="errorDialogDisplayed = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import systemEvent from "../lib/const/systemEvent";

export default {
  data() {
    return {
      errorDialogDisplayed: false,
      errorDialogTitle: "",
      errorDialogBody: "",
    };
  },

  async mounted() {
    const that = this;

    this.$app.eventBus.$on(systemEvent.USER_LIST_ERROR_DIALOG_CALLED, async (argHash) => {
      that.errorDialogTitle = argHash.errorDialogTitle;
      that.errorDialogBody = argHash.errorDialogBody;
      that.errorDialogDisplayed = argHash.errorDialogDisplayed;
    });
  },

  beforeDestroy() {
    this.$app.eventBus.$off(systemEvent.USER_LIST_ERROR_DIALOG_CALLED);
  },
};
</script>
